import { BackToLinks } from '../../../../types/BackToLinks';
import { BlockInnerTextButton } from '../../../Block/BlockInnerTextButton';

import type { FC } from 'react';

export type CompleteContentsProps = {
  backToLinks: BackToLinks;
};

export const CompleteContents: FC<CompleteContentsProps> = ({
  backToLinks,
}) => (
  <BlockInnerTextButton
    button="secondary"
    buttonText={backToLinks.buttonText}
    link={backToLinks.url}
  >
    {backToLinks.text}
  </BlockInnerTextButton>
);
